import { OnboardingData } from '@dev/ee-api/ee-api-models';
import { OnboardingSavedData, OnboardingVideoData } from '@/components/Onboarding/types';
import {
    OnboardingActionTypes,
    OnboardingState,
    SaveOnboardingErrorAction,
    SaveOnboardingStartAction,
    SaveOnboardingSuccessAction,
    LoadOnboardingStartAction,
    LoadOnboardingSuccessAction,
    LoadOnboardingErrorAction,
    OpenVideoOverlayAction,
    CloseVideoOverlayAction,
    FinishOnboardingAction,
} from './types';
import { ApplicationState } from '..';

export const SaveOnboardingStart = (payload: Partial<OnboardingSavedData>): SaveOnboardingStartAction => ({
    type: OnboardingActionTypes.SAVE_ONBOARDING_START,
    payload,
});

export const SaveOnboardingSuccess = (): SaveOnboardingSuccessAction => ({
    type: OnboardingActionTypes.SAVE_ONBOARDING_SUCCESS,
});

export const SaveOnboardingError = (): SaveOnboardingErrorAction => ({
    type: OnboardingActionTypes.SAVE_ONBOARDING_ERROR,
});

export const LoadOnboardingStart = (): LoadOnboardingStartAction => ({
    type: OnboardingActionTypes.LOAD_ONBOARDING_START,
});

export const LoadOnboardingSuccess = (payload: OnboardingData): LoadOnboardingSuccessAction => ({
    type: OnboardingActionTypes.LOAD_ONBOARDING_SUCCESS,
    payload,
});

export const LoadOnboardingError = (): LoadOnboardingErrorAction => ({
    type: OnboardingActionTypes.LOAD_ONBOARDING_ERROR,
});

export const OpenVideoOverlay = (payload: OnboardingVideoData): OpenVideoOverlayAction => ({
    type: OnboardingActionTypes.OPEN_VIDEO_OVERLAY,
    payload,
});

export const CloseVideoOverlay = (): CloseVideoOverlayAction => ({
    type: OnboardingActionTypes.CLOSE_VIDEO_OVERLAY,
});

export const FinishOnboarding = (): FinishOnboardingAction => ({
    type: OnboardingActionTypes.FINISH_ONBOARDING,
});

export const getOnboardingStore = (store: ApplicationState): OnboardingState => store.onboarding;
